export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const mediaUrl = node.data.mediaUrl || ''
  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false  

  let html = ''

  if (! mediaUrl) {
    $('#hover-node-card .card-body').html('')
  } else {
    html += `<p><strong>Media URL: </strong> <a href="${mediaUrl}" target="_blank">${mediaUrl}</a></p>`
    if (IsTypingOnDisplayChecked && delayReplyFor) {
      html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
    } 
    $('#hover-node-card .card-body').html(html)
  }
}